import React, { useEffect, useState } from "react";
import { Modal, Input } from "antd";
import { TaskExecution, useUpdateTaskExecutionMutation } from "shared/api";

interface Props {
  open: boolean;
  record: TaskExecution | null;
  onClose: () => void;
}

export const MessageEditModal: React.FC<Props> = ({
  open,
  record,
  onClose,
}) => {
  const [message, setMessage] = useState<string>("");
  const [updateTaskExecution, { isLoading }] = useUpdateTaskExecutionMutation();

  useEffect(() => {
    if (record?.message != null) setMessage(record.message);
  }, [record]);

  const handleOk = async () => {
    if (!record) return;

    await updateTaskExecution({
      id: record.id,
      data: { message },
    });

    onClose();
  };

  return (
    <Modal
      title="Update Message"
      open={open}
      onOk={handleOk}
      onCancel={onClose}
      confirmLoading={isLoading}
      okButtonProps={{
        className: "bg-blue-600 hover:bg-blue-700 text-white",
      }}
    >
      <Input.TextArea
        rows={4}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Enter message..."
      />
    </Modal>
  );
};
